import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Form, Input, Modal, Radio, Row, Select } from 'antd';

const FormItem = Form.Item;
const { Option } = Select;
const Textarea = Input;

class IndexModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  submit = () => {
    const { data } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        values.unid = data ? data.unid : '';
        this.props.onOk(values);
        this.props.form.resetFields();
      }
    });
  };

  onCancel = () => {
    this.props.form.resetFields();
    this.props.onCancel();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data } = this.props;
    const ItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    return (
      <Modal
        title={data && data.uuid ? '编辑菜单栏' : '创建菜单栏'}
        visible={this.props.visible}
        onOk={this.submit}
        onCancel={this.onCancel}
      >
        <Form>
          <Row>
            <Col span={20}>
              <FormItem label="所属系统" {...ItemLayout}>
                {getFieldDecorator('crappUuid', {
                  rules: [{ required: true, message: '所属系统!' }],
                  initialValue: data && data.uuid ? data.crappUuid : 'bszb',
                })(
                  <Select>
                    <Option value="core">系统平台</Option>
                    <Option value="bszb">帮实资本投资管理决策系统</Option>
                  </Select>,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="标识UUID" {...ItemLayout}>
                {getFieldDecorator('uuid', {
                  rules: [{ required: true, message: '请输入标识UUID!' }],
                  initialValue: data && data.uuid ? data.uuid : '',
                })(<Input placeholder="标识UUID" disabled={data && data.uuid} />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="角色名称" {...ItemLayout}>
                {getFieldDecorator('name', {
                  rules: [{ required: true, message: '角色名称!' }],
                  initialValue: data && data.uuid ? data.name : '',
                })(<Input placeholder="角色名称" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="角色状态" {...ItemLayout}>
                {getFieldDecorator('status', {
                  rules: [{ required: true, message: '角色状态!' }],
                  initialValue: data && data.uuid ? data.status : 1,
                })(
                  <Radio.Group>
                    <Radio value={1}>启用</Radio>
                    <Radio value={0}>禁用</Radio>
                  </Radio.Group>,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="备注" {...ItemLayout}>
                {getFieldDecorator('remark', {
                  initialValue: data && data.uuid ? data.remark : '',
                })(<Textarea placeholder="备注" />)}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Form.create()(IndexModal));



// WEBPACK FOOTER //
// ./src/components/boss/role/ModalRoleAdd.js